import { useBreakpoint } from '~/hooks';
import AutoGenerateButton from '~addListing/pages/ListingDescription/AutoGenerateButton';
import { AutoGenerateButtonProps } from '~addListing/pages/ListingDescription/types';

export default function InputLabel({
  isLoading,
  isSuccess,
  title,
  handleGenerateValueByAI,
  language,
}: AutoGenerateButtonProps & {
  title: string;
}) {
  const { mobileScreen } = useBreakpoint();

  return (
    <div className="flex justify-between">
      <p className="text-title_4 text-black">{title}</p>
      {mobileScreen && (
        <AutoGenerateButton
          isLoading={isLoading}
          isSuccess={isSuccess}
          handleGenerateValueByAI={handleGenerateValueByAI}
          language={language}
        />
      )}
    </div>
  );
}
